import { render } from "./TestimonialCard.vue?vue&type=template&id=848f2a34"
import script from "./TestimonialCard.vue?vue&type=script&lang=ts"
export * from "./TestimonialCard.vue?vue&type=script&lang=ts"
script.render = render

export default script